module.exports = __webpack_public_path__ + "img/preview-aye.745a4bf3.svg";